/**
 * Onboarding step ids for presentation
 */
export enum PresentationOnboardingStep {
  Navigation = 'presentation-navigation',
  Share = 'presentation-share',
  Presence = 'presentation-presence',
}

/**
 * Onboarding step ids for ai copilot
 */
export enum AiCopilotOnboardingStep {
  Widget = 'ai-copilot-widget',
  Window = 'ai-copilot-window',
}

/**
 * Onboarding step ids for ai design generator
 */
export enum AiDesignGeneratorOnboardingStep {
  Generator = 'ai-design-generator',
}

/**
 * Onboarding step ids for ai design generator
 */
export enum AiSetsGeneratorOnboardingStep {
  Generator = 'ai-sets-generator',
}

/**
 * union for all supported onboarding steps
 */
export type FeatureOnboardingSteps =
  | PresentationOnboardingStep
  | AiCopilotOnboardingStep
  | AiDesignGeneratorOnboardingStep
  | AiSetsGeneratorOnboardingStep;
